var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-menu-item",class:{ disabled: _vm.disabled },on:{"click":_vm.navigate}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":require(("@/assets/" + _vm.icon))}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0e662f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/app-header/NavigationMenuItem.vue
// module id = null
// module chunks = 